/**
 * Fix for Foundation SmoothScroll offset issue
 * This script overrides the default Foundation SmoothScroll behavior
 * to properly account for the header height
 */

document.addEventListener('DOMContentLoaded', function() {
	function getHeaderHeight() {
		const header = document.querySelector('.site-header');
		if (header) {
				return header.offsetHeight;
		}
		return 124;
	}

	// Wait for Foundation to be available
	if (typeof Foundation !== 'undefined' && Foundation.SmoothScroll) {
		// Override the default offset to account for header height
		Foundation.SmoothScroll.defaults.offset = getHeaderHeight();

		const originalScrollToLoc = Foundation.SmoothScroll.scrollToLoc;
		Foundation.SmoothScroll.scrollToLoc = function(location, options, callback) {
			const opts = options || Foundation.SmoothScroll.defaults;
			const $target = $(location);

			if (!$target.length) return false;
				const scrollTop = Math.round($target.offset().top - opts.offset);

				$('html, body').stop(true).animate({
					scrollTop: scrollTop
				}, opts.animationDuration, opts.animationEasing, function() {
					if (typeof callback === 'function') {
						callback();
					}
				});
			};
    }

    // Handle anchor clicks manually if Foundation isn't working properly
    document.addEventListener('click', function(e) {
			const link = e.target.closest('a[href^="#"]:not(.accordion-title)');
			if (link && link.getAttribute('href') !== '#') {
				const targetId = link.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);

				if (targetElement) {
					e.preventDefault();

					const headerHeight = getHeaderHeight();
					const targetPosition = targetElement.offsetTop - headerHeight;

					window.scrollTo({
						top: Math.max(0, targetPosition),
						behavior: 'smooth'
					});
				}
			}
    });
});
